import React from 'react'
const DocIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8333 2.75V6.41667C12.8333 6.92293 13.2437 7.33333 13.75 7.33333H17.4167"
      stroke="#A4A4A4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5833 19.25H6.41668C5.40415 19.25 4.58334 18.4292 4.58334 17.4167V4.58333C4.58334 3.57081 5.40415 2.75 6.41668 2.75H12.8333L17.4167 7.33333V17.4167C17.4167 18.4292 16.5959 19.25 15.5833 19.25Z"
      stroke="#A4A4A4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 8.24999H9.16667"
      stroke="#A4A4A4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 11.9167H13.75"
      stroke="#A4A4A4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 15.5833H13.75"
      stroke="#A4A4A4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DocIcon;